export default {"src":"/_next/static/media/qualifying-item-badge-1.de221a55.svg","height":152,"width":152,"blurWidth":0,"blurHeight":0};